import React from 'react';
import PropTypes from 'prop-types';
import memoize from "memoize-one";
import { Radio, Button, Table, Progress, Popconfirm } from 'antd';
import isEmpty from 'lodash/isEmpty';

import { CHAT_TRANSFER_TO, AGENT_STATUS, COLORS } from '../../../../../../../data/config/constants';
import { uniqueId, log } from '../../../../../../../data/config/utils';
import { IMG_EMPTY } from '../../../../../../../data/assets/img';

import SelectItem from '../../../../../../../components/form/selectitem';
import ProfileAvatar from '../../../../../../../components/profileavatar';
import ShowMessage from '../../../../../../../components/showmessage';

class TransferChat extends React.PureComponent {
  constructor(props) {
    super(props);
    this.columns = this.getAgentTableColumns();
    this.state = {
      transfer_to: CHAT_TRANSFER_TO.AGENT,
    }
  }

  componentWillUnmount() {
    const { leaveAgentTransfer } = this.props;
    if (leaveAgentTransfer)
      leaveAgentTransfer();
  }

  getAgentTableColumns = () => {
    const columns = [
      {
        title: '',
        dataIndex: 'name',
        key: 'name',
        className: 'ori-l-pad-10',
        render: (text, record) => {
          return (
            <ProfileAvatar shape="square" container_class="ori-flex-ac" title={`${record.firstName} ${record.lastName}`} title_class="ori-font-sm ori-font-bold" default_avatar_bg={record.online !== "true"} badge_dot={record.online === "true"} status={record.currentlyAcceptingChats === AGENT_STATUS.ACCEPTING ? "success" : "error"} />
          );
        }
      },
      {
        title: '',
        dataIndex: 'avaliability',
        key: 'avaliability',
        render: (text, record) => {
          return (
            <Progress size="small" className={record.currentlyHandlingChat === record.chatConcurrency ? "ori-progress-text-color-danger" : ""} strokeColor={record.currentlyHandlingChat === record.chatConcurrency ? COLORS.danger : COLORS.green} percent={(record.currentlyHandlingChat / record.chatConcurrency) * 100} format={() => `${record.currentlyHandlingChat}/${record.chatConcurrency}`} />
          );
        }
      },
      {
        title: '',
        dataIndex: 'action',
        key: 'action',
        align: 'center',
        render: (text, record) => {
          let disabled=false;
          if(record.role !== "Supervisor"){
            disabled = (record.currentlyHandlingChat === record.chatConcurrency) || (record.online !== "true") || (record.currentlyAcceptingChats !== AGENT_STATUS.ACCEPTING) || (record.psid === this.props.admin_id);
            }
          else if(record.role === "Supervisor"){ 
            disabled = (record.currentlyHandlingChat === record.chatConcurrency) || (record.online !== "true") || (record.psid === this.props.admin_id)||(record.state ==="1st break")||(record.state ==="2nd break")||(record.state ==="out for lunch")||(record.state ==="out for dinner");
            }
          if (disabled) {
            return (<Button type="primary" disabled={disabled}>Transfer</Button>);
          }
          return (
            <Popconfirm placement="topRight" title="Are you sure want to transfer to this agent?" okText="Yes" cancelText="No" onConfirm={this.onClickAgentTransfer.bind(this, record)}>
              <Button type="primary">Transfer</Button>
            </Popconfirm>
          );
        }
      },
    ];
    return columns;
  };

  memorizedAgentTableData = memoize(agentList => {
    let data = [];
    Object.keys(agentList).forEach(agentPsid => {
      data.push(agentList[agentPsid]);
    });
    log('data', data);
    return data;
  });

  onClickAgentTransfer = agent => {
    this.props.transferToAgent(CHAT_TRANSFER_TO.AGENT, agent);
  };

  onClickGroupTransfer = () => {
    this.props.transferToAgent(CHAT_TRANSFER_TO.GROUP);
  };

  onChangeTransferTo = event => {
    this.setState({
      transfer_to: event.target.value
    });
  };

  renderAgentTable = () => {
    const { transfer_chat } = this.props;
    const { transfer_to } = this.state;
    if (transfer_to === CHAT_TRANSFER_TO.AGENT) {
      if (!isEmpty(transfer_chat.agent_list)) {
        const dataSource = this.memorizedAgentTableData(transfer_chat.agent_list);
        log('tableData', dataSource);
        return (
          <Table className="ori-card-row-table ori-table-header-display-none" rowClassName="ori-bg-white" scroll={{ x: 300 }} rowKey={uniqueId} columns={this.columns} pagination={false} dataSource={dataSource} />
        );
      }
      return (
        <ShowMessage img_src={IMG_EMPTY} title="Empty" message="agent list does not found" height={150} width={150} />
      );
    }
  };

  renderTransferGroupButton = () => {
    const { transfer_chat } = this.props;
    const disabled = transfer_chat.selected_group === "";
    if (!disabled) {
      return (
        <Popconfirm placement="topRight" title="Are you sure want to transfer to this group?" okText="Yes" cancelText="No" onConfirm={this.onClickGroupTransfer}>
          <Button type="primary">Transfer</Button>
        </Popconfirm>
      );
    }
    return (
      <Button type="primary" disabled={disabled}>Transfer</Button>
    );
  };

  render() {
    const { groups, transfer_chat, onChangeGroup } = this.props;
    const { transfer_to } = this.state;
    return (
      <div className="ori-pad-15">
        <div className="ori-text-center">
          <span className="ori-font-xs ori-r-pad-10 ori-font-light">Transfer to : </span>
          <Radio.Group size="small" buttonStyle="solid" value={transfer_to} onChange={this.onChangeTransferTo}>
            <Radio.Button className="ori-font-normal ori-font-xs ori-capitalize" value={CHAT_TRANSFER_TO.AGENT}>{CHAT_TRANSFER_TO.AGENT}</Radio.Button>
            <Radio.Button className="ori-font-normal ori-font-xs ori-capitalize" value={CHAT_TRANSFER_TO.GROUP}>{CHAT_TRANSFER_TO.GROUP}</Radio.Button>
          </Radio.Group>
        </div>
        <div className="ori-flex ori-flex-wrap ori-t-pad-10 ori-lr-mrgn-neg-10">
          <div className="ori-pad-10 ori-mobile-full-width ori-half-width">
            <SelectItem title="Group" placeholder="select group" options={groups} name_key="name" value_key="name" value={transfer_chat.selected_group} onChange={onChangeGroup} is_option_object_type />
          </div>
          {
            transfer_to === CHAT_TRANSFER_TO.GROUP &&
            <div className="ori-pad-10 ori-mobile-full-width ori-half-width ori-flex-column ori-flex-jfe">
              <div className="ori-tb-pad-5">
                {this.renderTransferGroupButton()}
              </div>
            </div>
          }
        </div>
        {this.renderAgentTable()}
      </div>
    );
  }
}

TransferChat.propTypes = {
  admin_id: PropTypes.string.isRequired,
  groups: PropTypes.array,
  transfer_chat: PropTypes.object,
  onChangeGroup: PropTypes.func,
  transferToAgent: PropTypes.func,
  leaveAgentTransfer: PropTypes.func,
};

TransferChat.defaultProps = {
  groups: [],
  transfer_chat: {
    agent_list: [],
    selected_group: ""
  },
  transferToAgent: () => { },
}

export default TransferChat;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/chats/components/chatdrawer/transferchat/index.js